<template>
  <div class="row">
    <div class="contain-all Bold">
      <div class="center-all">
        <Breadcrumbs ref="breadcrumbs"></Breadcrumbs>
        <innerTab></innerTab>      
        <div class="digital-marketing col-md-12" ref="digitalMarketing">
          <div class="magezine-select-all col-md-4 col-md-offset-4" @click="magezineSelectAll">
            <div class="magezine-select" v-on:click="selectMagezine">
              <p class="digital-marketing-title" v-if="magazineP">{{magazineP}}</p>
              <i class="icon-arrow-down magezine-select-icon Bold"></i>
            </div>
            <div class="magezine-select-list">
              <!-- <div class="digital-marketing-title magezine-select-item" v-on:click="selectIssue(magazine.id,magazine)" v-for="(magazine,index) in magazineList">
                        <span>{{magazine.issueNumber}}&nbsp;{{$store.getters.getObject(magazine.langMap).title}}
                            {{articleList.length}}</span>
              </div>-->
              <div
                class="digital-marketing-title magezine-select-item"
                v-on:click="selectIssue(magazine.id,magazine)"
                v-for="(magazine,index) in magazineList"
              >004 Wedding Property</div>
              <div
                class="digital-marketing-title magezine-select-item"
                v-on:click="selectIssue(magazine.id,magazine)"
                v-for="(magazine,index) in magazineList"
              >004 Wedding Property</div>
              <div
                class="digital-marketing-title magezine-select-item orangeChenge"
                v-on:click="selectIssue(magazine.id,magazine)"
                v-for="(magazine,index) in magazineList"
              >004 Wedding Property</div>
            </div>
          </div>
        </div>
        <div class="col-md-12 digital digital-marketing-content">
          <div class="col-xs-12 col-sm-12 col-md-7 pad-0">
            <div class="digital-marketing-placeImg">
              <img
                class="digital-marketing-img"
                v-bind:src="$store.getters.getObject(featureStory.langMap).coverPhoto"
                alt
              />
              <div class="digital-placeImg-information col-xs-12 col-sm-12">
                <div class="digital-information-title Bold">政府吉祥物玩轉社交網幕後團隊：劍走偏鋒，險中求勝作節奏</div>
                <div class="digital-information-detail Regular">
                  今時今日做政府吉祥物，需要的已經不再只是頭套和搞怪
                  動作，要得人心，尤其是年輕人心。還要識玩社交媒體。
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-5 digital-marketing-rightList">
            <div class="hot-picks-ad hot-picks-adAll digital-marketing-ad">
              <div class="col-xs-6 col-sm-6 col-md-6 hot-picks-placeImg pad-0">
                <img class="hot-picks-img" src="../images/quhua.png" alt />
                <div class="positive"></div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="hot-picks-subtitle issue-subtitle">飛雲有計</div>
                <div class="hot-picks-information issue-information">
                  <span class="hover-line issue-hover-line">廣告應該給誰看：活於騙局的廣告業</span>
                </div>
              </div>
            </div>

            <div class="hot-picks-ad hot-picks-adAll digital-marketing-ad">
              <div class="col-xs-6 col-sm-6 col-md-6 hot-picks-placeImg pad-0">
                <img class="hot-picks-img" src="../images/quhua.png" alt />
                <div class="positive"></div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="hot-picks-subtitle issue-subtitle">飛雲有計</div>
                <div class="hot-picks-information issue-information">
                  <span class="hover-line issue-hover-line">廣告應該給誰看：活於騙局的廣告業</span>
                </div>
              </div>
            </div>
            <div class="hot-picks-ad hot-picks-adAll digital-marketing-ad">
              <div class="col-xs-6 col-sm-6 col-md-6 hot-picks-placeImg pad-0">
                <img class="hot-picks-img" src="../images/quhua.png" alt />
                <div class="positive"></div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="hot-picks-subtitle issue-subtitle">飛雲有計</div>
                <div class="hot-picks-information issue-information">
                  <span class="hover-line issue-hover-line">廣告應該給誰看：活於騙局的廣告業</span>
                </div>
              </div>
            </div>
            <div class="hot-picks-ad hot-picks-adAll digital-marketing-ad">
              <div class="col-xs-6 col-sm-6 col-md-6 hot-picks-placeImg pad-0">
                <img class="hot-picks-img" src="../images/quhua.png" alt />
                <div class="positive"></div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="hot-picks-subtitle issue-subtitle">飛雲有計</div>
                <div class="hot-picks-information issue-information">
                  <span class="hover-line issue-hover-line">廣告應該給誰看：活於騙局的廣告業</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-xs-6 digital-marketing-text col-md-4">
                <div class="digital-marketing-bigText">
                    {{featureStory.subCategoryList[0].langMap}} 
                    subcat{{featureStory.subCategoryList?$store.getters.getObject(featureStory.subCategoryList[0].langMap).content:''}}
                    {{$store.getters.getObject(featureStory.langMap).title}}
                </div>
                <div class="digital-marketing-smallText">
                    {{$store.getters.getObject(featureStory.langMap).shortDescription}}
                </div>
          </div>-->
        </div>
        <!-- <div class="col-xs-12 ad pad-0">
      <div class="col-xs-12 ad-contain pad-0" v-for="(article,index) in sideStory" :key="index">
        <div class="col-xs-6 col-sm-12 col-md-12 ad-contain-placeImg pad-0">
          <img
            class="ad-contain-img"
            :src="$store.getters.getObject(article.langMap).coverPhoto"
            alt
          />
          <div class="positive"></div>
        </div>
        <div class="col-xs-6 col-sm-12 col-md-12">
          <div
            class="ad-contain-subtitle"
          >{{$store.getters.getObject(article.subCategoryList[0].langMap).content}}</div>
          <p></p>
          <div class="ad-contain-information">
            <span class="hover-line">{{$store.getters.getObject(article.langMap).title}}</span>
          </div>
        </div>
      </div>
        </div>-->

        <div class="col-xs-12 column online-bottomList">
          <!-- <div class="column-title">Column</div>
      {{column}}
      <div class="column-item col-xs-12" v-for="(article,index) in column" :key="index">
        <div class="column-item-information col-xs-12 pad-0">
          <p>
            <span class="column-item-place">
              {{$store.getters.getObject(article.subCategoryList[0].langMap).content}}
              <span>|</span>
            </span>
            {{$store.getters.getObject(article.langMap).title}}
          </p>
          <p>營銷的最高境界</p>
        </div>
        <div class="column-item-people col-xs-12 padLR">
          <div class="column-name">{{$store.getters.getObject(article.langMap).authorName}}</div>
          <div class="circle-chart">
            <img
              class="circle-chartImg"
              v-bind:src="$store.getters.getObject(article.langMap).authorIcon"
              alt
            />
          </div>
        </div>
          </div>-->
          <div class="column-item col-xs-12 col-sm-12 col-md-3">
            <div class="column-item-information col-xs-12 pad-0">
              <p>
                <span class="column-item-place">
                  创界山
                  <span>|</span>
                </span>以高質的內容加 Hard
              </p>
              <p>營銷的最高境界</p>
            </div>
            <div class="column-item-people col-xs-12 padLR">
              <div class="column-name Regular">吳博林</div>
              <div class="circle-chart-content">
                <div class="circle-chart">
                  <img class="circle-chartImg" src="../images/aa.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="column-item col-xs-12 col-sm-12 col-md-3">
            <div class="column-item-information col-xs-12 pad-0">
              <p>
                <span class="column-item-place">
                  创界山
                  <span>|</span>
                </span>以高質的內容加 Hard
              </p>
              <p>營銷的最高境界</p>
            </div>
            <div class="column-item-people col-xs-12 padLR">
              <div class="column-name Regular">吳博林</div>
              <div class="circle-chart-content">
                <div class="circle-chart">
                  <img class="circle-chartImg" src="../images/aa.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="column-item col-xs-12 col-sm-12 col-md-3">
            <div class="column-item-information col-xs-12 pad-0">
              <p>
                <span class="column-item-place">
                  创界山
                  <span>|</span>
                </span>以高質的內容加 Hard
              </p>
              <p>營銷的最高境界</p>
            </div>
            <div class="column-item-people col-xs-12 padLR">
              <div class="column-name Regular">吳博林</div>
              <div class="circle-chart-content">
                <div class="circle-chart">
                  <img class="circle-chartImg" src="../images/aa.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import { EventBus } from "@/javascripts/eventBus.js";
import innerTab from "@/components/innerTab";
export default {
  components: {
    Breadcrumbs,
    innerTab
  },
  created() {},
  data() {
    return {
      // issueContent:{},
      featureStory: [],
      sideStory: [],
      column: [],
      articleList: [],
      magazineList: [],
      magazineP: "",
      entrySelect: false,
      categoryList: [],
      magazineId: 0,
        }
    },   
  mounted() {
    EventBus.$emit("error", { errMsg: this.$i18n.t("message.developmentTip") });
    this.$store.state.selectMenu = 1;
    this.getCategoryList();
    this.getMagazineList();
  },
  methods: {
    getIssueContent: function(magazineId) {
      let that = this;
      this.api.getIssueContent({ magazineId: magazineId }, function(data) {
        // 
        // that.issueContent = data.result;
        that.featureStory = data.result[0].articleList[0];
        that.sideStory = data.result[1] ? data.result[1].articleList : [];

        that.column = data.result[2] ? data.result[2].articleList : [];
      });
    },
    magezineSelectAll: function() {},
    selectMagezine: function() {
      let magezineSelectList = document.getElementsByClassName(
        "magezine-select-list"
      )[0];
      let open = document.getElementsByClassName("open")[0];
      let magezineSelectIcon = document.getElementsByClassName(
        "magezine-select-icon"
      )[0];
      if (open == undefined) {
        magezineSelectList.classList.add("open");
        magezineSelectIcon.classList.add("open");
      } else {
        magezineSelectList.classList.remove("open");
        magezineSelectIcon.classList.remove("open");
      }
    },
    getMagazineList: function() {
      let that = this;
      this.api.getMagazineList({}, function(data) {
        // that.course=data.result;
        // 
        that.magazineList = data.result;

        that.selectIssue(that.magazineList[0].id, that.magazineList[0]);
        // 
      });
    },
    selectIssue: function(issueId, magazine) {
      if (magazine) {
        this.magazineP =
          magazine.issueNumber +
          " " +
          this.$store.getters.getObject(magazine.langMap).title +
          " " +
          this.articleList.length;
      }

      let postData = { startRow: 0, maxRows: 10 };
      this.magazineId = issueId;
      // 

      //换动画
      if (this.entrySelect) {
        this.selectMagezine();
      }
      this.entrySelect = true;
    },
    getCategoryList: function() {
      let that = this;
      this.api.getCategoryList({}, function(data) {
        that.categoryList = data.result;
      });
    }
  },
  watch: {
    magazineId() {
      this.getIssueContent(this.magazineId);
    }
  }
};
</script>